import React from 'react';
import { Alert } from '../Alert/Alert';
import { localise } from '../../../services/lang/lang';
const ModalErrorMessageBox = (props) => {
    if (!props.hasErrors || !props.errors)
        return null;
    const getErrorComponent = (error) => (React.createElement("p", { "data-testid": "error_text" }, error));
    const errors = Object.entries(props.errors).flatMap(([, error]) => {
        if (typeof error === 'string') {
            return getErrorComponent(error);
        }
        return Object.values(error).flatMap((innerError) => getErrorComponent(innerError));
    });
    return (React.createElement(Alert, { status: "error", title: localise('SOMETHING_WRONG'), icon: true, "data-testid": "error-aware-alert-box" }, errors));
};
export default ModalErrorMessageBox;
